import { useEffect, useRef, useState } from 'react';

import { useBetSlice } from '../store/slices/bets/selectors';
import { useGameStateSlice } from '../store/slices/game/selectors';

/** Has the totalBet value increased after subscribing to the game server?
 * Changes to totalBet made before subscribing to the server should not be taken into account.
 */
export const useTotalBetAfterSubscription = (): boolean => {
  const totalBet = useBetSlice.totalBet();
  const isSubscribed = useGameStateSlice.getGameSubscribed();

  const [hasTotalBetChanged, setHasTotalBetChanged] = useState(false);
  const initialBetRef = useRef<number | null>(null);

  useEffect(() => {
    if (isSubscribed && initialBetRef.current === null) {
      initialBetRef.current = totalBet;
    } else if (isSubscribed && initialBetRef.current !== null && totalBet > initialBetRef.current) {
      setHasTotalBetChanged(true);
    } else if (isSubscribed && initialBetRef.current !== null && totalBet < initialBetRef.current) {
      initialBetRef.current = totalBet;
      setHasTotalBetChanged(false);
    }
  }, [isSubscribed, totalBet]);

  return hasTotalBetChanged;
};
